__turbopack_context__.v({
  "Container": "JwwkdW_Container",
  "Crumb": "JwwkdW_Crumb",
  "First": "JwwkdW_First",
  "Last": "JwwkdW_Last",
  "Link": "JwwkdW_Link",
  "ListItem": "JwwkdW_ListItem",
  "Root": "JwwkdW_Root",
});
